import React from 'react'
import * as DropdownMenu from '@radix-ui/react-dropdown-menu'
import { TrashDelete, OverflowMenu, FileDownload, Drafting, InfoCircle } from '@/assets/icons'

function classNames(...classes: any) {
  return classes.filter(Boolean).join(' ')
}

type Props = {
  onSelect: () => void
  onRenameClick: () => void
  onDeleteClick: () => void
  onDownloadClick?: () => void
  onLogMetadata?: () => void
}

const ItemActionsMenu: React.FC<Props> = (props: Props) => {
  const { onSelect, onRenameClick, onDownloadClick, onDeleteClick, onLogMetadata } = props

  const menuElements = [
    {
      name: 'Rename',
      icon: Drafting,
      current: false,
      onClick: () => onRenameClick(), //Will open the rename modal
    },
    {
      name: 'Delete',
      icon: TrashDelete,
      current: false,
      onClick: () => onDeleteClick(),
    },
  ]

  if (onDownloadClick) {
    menuElements.push({
      name: 'Download',
      icon: FileDownload,
      current: false,
      onClick: () => onDownloadClick(),
    })
  }

  if (process.env.NODE_ENV === 'development' && onLogMetadata) {
    menuElements.push({
      name: 'Log Metadata',
      icon: InfoCircle,
      current: false,
      onClick: () => onLogMetadata(),
    })
  }

  return (
    <DropdownMenu.Root>
      <DropdownMenu.Trigger asChild>
        <button className={`p-2`}>
          <OverflowMenu width={18} height={18} className={'hover:text-brand-500'} />
        </button>
      </DropdownMenu.Trigger>

      <DropdownMenu.Portal>
        <DropdownMenu.Content
          className="z-50 min-w-[200px] bg-brand-neutral-50 rounded-md p-[5px] shadow-[0px_0px_10px_-3px_#D1D0CC] will-change-[opacity,transform] data-[side=top]:animate-slideDownAndFade data-[side=right]:animate-slideLeftAndFade data-[side=bottom]:animate-slideUpAndFade data-[side=left]:animate-slideRightAndFade"
          side="top"
          align="end"
        >
          <ul role="list" className="space-y-1.5">
            {menuElements.map((item) => (
              <li key={item.name} onMouseEnter={() => (item.current = true)}>
                <DropdownMenu.Item
                  onClick={() => {
                    item.onClick()
                    onSelect()
                  }}
                  className={classNames(
                    item.current
                      ? 'bg-brand-neutral-50 text-brand-500'
                      : 'text-brand-neutral-700 hover:text-brand-500 hover:bg-brand-neutral-100 cursor-pointer',
                    'rounded-md group flex items-center flex-nowrap gap-x-2.5 py-[2px] text-sm leading-6 w-full'
                  )}
                >
                  <item.icon className={classNames(item.current ? 'text-brand-500' : 'h-5 w-5 shrink-0')} aria-hidden="true" />
                  <div className={`whitespace-nowrap `}>{item.name}</div>
                </DropdownMenu.Item>
              </li>
            ))}
          </ul>

          <DropdownMenu.Arrow className="fill-white" />
        </DropdownMenu.Content>
      </DropdownMenu.Portal>
    </DropdownMenu.Root>
  )
}

export default ItemActionsMenu
